import axios from "axios";
import { getBackendUrl, getEnvToken } from "../config";
import { logHttpError } from "./frontendLogger";

const api = axios.create({
  baseURL: getBackendUrl(),
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const tokenStorage = localStorage.getItem("token");
    if (tokenStorage) {
      let parsedToken = tokenStorage;
      try {
        parsedToken = JSON.parse(tokenStorage);
      } catch (error) {
        parsedToken = tokenStorage;
      }
      config.headers["Authorization"] = `Bearer ${parsedToken}`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    try {
      const method = String(response?.config?.method || "").toLowerCase();
      const url = String(response?.config?.url || "");
      const isWriteMethod = ["post", "put", "patch", "delete"].includes(method);
      const isTicketMutation =
        /\/tickets(\/|$)/.test(url) || /\/ticket-tags(\/|$)/.test(url);
      const isTicketPinMutation = /(?:^|\/)tickets\/[^/]+\/pin(?:\/|\?|$)/.test(
        url
      );

      if (isWriteMethod) {
        window.dispatchEvent(
          new CustomEvent("api:mutation", {
            detail: {
              method,
              url,
              payload: response?.data || null,
            },
          })
        );
      }

      if (isWriteMethod && isTicketMutation && !isTicketPinMutation) {
        window.dispatchEvent(
          new CustomEvent("tickets:changed", {
            detail: {
              method,
              url,
              payload: response?.data || null,
            },
          })
        );
      }
    } catch (_) {}

    return response;
  },
  (error) => {
    logHttpError(error);
    if (
      error.response &&
      error.response.data &&
      error.response.data.error === "ERR_QUOTA_EXCEEDED"
    ) {
      const event = new Event("ERR_QUOTA_EXCEEDED");
      window.dispatchEvent(event);
    }
    return Promise.reject(error);
  }
);

export const openApi = axios.create({
  baseURL: getBackendUrl(),
});

openApi.interceptors.request.use(
  (config) => {
    const token = getEnvToken();
    if (token) {
      config.params = { ...(config.params || {}), token };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
